import React from 'react'
import ExcelUpload from '../../components/common/excel-upload/excel-upload'

const GemiTahliyeExcel = () => {
    return (
        <>
            <ExcelUpload
                role_name={"gemi_exceltahliye_write"}
                requiredColumnsSase={["sase"]}
                process_type="SHIP_UNLOAD"
                ExcelName={"Gemi Tahliye Hatalı Şaseler"}
                Title={"Gemi Tahliye"}
                depo={true}
                exampleData={[{ sase: "VF3YEF6F0RMA03711" }]}
            />
        </>
    )
}

export default GemiTahliyeExcel